/**
 * Human-readable date+time for advisor UI. No seconds.
 * EN example: "12 Apr 2026, 3:37 PM"
 * ES example: "12 abr 2026, 3:37 p. m." (locale-dependent)
 *
 * @param {string|number|Date|null|undefined} iso
 * @param {string} [i18nLanguage] i18n.language (e.g. "en", "es")
 * @returns {string}
 */
export function formatDisplayDateTime(iso, i18nLanguage = 'en') {
  if (iso == null || iso === '') return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return typeof iso === 'string' ? iso : '—';
  const isEs = String(i18nLanguage || 'en').toLowerCase().startsWith('es');
  if (isEs) {
    const dateStr = d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' });
    const timeStr = d.toLocaleTimeString('es-ES', { hour: 'numeric', minute: '2-digit', hour12: true });
    return `${dateStr}, ${timeStr}`;
  }
  const dateStr = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${dateStr}, ${timeStr}`;
}
